export default function formatCurrency(input) {
    let val = (input/1).toFixed(2).replace('.', ',');
    return `$${val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")}`;
}